import { twMerge } from "tailwind-merge";

import { ClassName } from "shared/types";

export const Footer = ({ className }: ClassName) => {
  const year = new Date().getFullYear();
  return (
    <footer
      className={twMerge(
        "border-athensGray text-paleSky flex items-center justify-center border-t pt-8 pb-12 leading-6 font-light",
        className
      )}
    >
      © {year} Occam.fi Data Provider. All rights reserved.
    </footer>
  );
};
